<template>
  <van-popup
    :value="visible"
    position="center"
    round
    :close-on-click-overlay="false"
    get-container="body"
    :z-index="2100"
    class="exit-confirm-popup"
  >
    <div class="exit-confirm-dialog">
      <p class="exit-confirm-text">
        本次投诉尚未提交，<br />确定放弃本次维权吗？
      </p>
      <div class="exit-confirm-actions">
        <button class="exit-btn exit-btn-cancel" @click="handleAbandon">
          放弃维权
        </button>
        <button class="exit-btn exit-btn-confirm" @click="handleContinue">
          继续提交
        </button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "ExitConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAbandon() {
      this.$emit("abandon");
    },
    handleContinue() {
      this.$emit("continue");
    },
  },
};
</script>

<style lang="less" scoped>
.exit-confirm-popup {
  width: 295px;
  background: transparent;
}

.exit-confirm-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-sizing: border-box;
}

.exit-confirm-text {
  margin: 0;
  color: #333;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
}

.exit-confirm-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
  gap: 16px;
}

.exit-btn {
  flex: 1;
  border: none;
  border-radius: 20px;
  padding: 9px 0;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.exit-btn-cancel {
  background: #fff;
  border: 0.5px solid #999;
  color: #444;
}

.exit-btn-confirm {
  background: #4fa4d3;
  color: #fff;
}
</style>
